import React from 'react';
import { PageHeader, Button, Modal, Radio, Input, Select } from 'antd';
import { ACTIVATION_STATUS } from '../../constants';
import './styles.scss';
import StatusToggler from 'components/UI/Toggler/StatusToggler';
import { AM_TYPES } from 'constants/Global';
import { AuthRoleIds } from 'constants/Auth';

const CustomerDetailHeader = ({
  customer,
  listOfAM,
  updateAccountManager,
  currentUser,
  deactivateCustomer,
}) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [showAmEditModal, setShowAmEditModal] = React.useState(false);
  const [value, setValue] = React.useState("");
  const [greigeAM, setGreigeAM] = React.useState({});
  const [processingAM, setProcessingAM] = React.useState({});
  const [denimAM, setDenimAM] = React.useState({});
  const [ist, setIst] = React.useState({});
  const [comment, setComment] = React.useState("");
  const [amChanges, setAmChanges] = React.useState({
    greige: false,
    processing: false,
    denim: false,
    ist: false,
  });

const accountManagers = customer?.accountManagers ?? [];

const AM_USER_ROLE_TYPE = 10;
const IST_USER_ROLE_TYPE = 30;

const amList = accountManagers.filter((am) => am.userRoleType == AM_USER_ROLE_TYPE);
const istUser = accountManagers.find((am) => am.userRoleType == IST_USER_ROLE_TYPE) || null;

const TYPED_AM_TYPES = [1, 2, 3];
const hasTypedAM = amList.some((am) => TYPED_AM_TYPES.includes(am.type));

const findAM = (type) => amList.find((am) => am.type === type) || null;

const defaultAM = amList[0] || null;

const greige_AM = hasTypedAM ? findAM(1) : defaultAM;
const processing_AM = hasTypedAM ? findAM(2) : defaultAM;
const denim_AM = hasTypedAM ? findAM(3) : defaultAM;

const filteredAMRoles = listOfAM?.filter(
  ({ role }) => [String(AuthRoleIds.ACCOUNT_MANAGER), String(AuthRoleIds.SUPPLY_HEAD)].includes(role)
);

const filteredISTRoles = listOfAM?.filter(
  ({ role }) => role === String(AuthRoleIds.IST)
);

  React.useEffect(() => {
    if (customer?.accountManagers?.length) {
      const accountManagers = customer.accountManagers;  
      if (accountManagers.length === 1) {
        const amObject = {
          newAccountManagerId: greige_AM?.id,
          name: greige_AM?.name,
        };
        const istObject = {
          newAccountManagerId: istUser?.id,
          name: istUser?.name,
        };
        setGreigeAM(amObject);
        setProcessingAM(amObject);
        setDenimAM(amObject);
        setIst(istObject);
      } else {
        setGreigeAM({
          newAccountManagerId: greige_AM?.id || null,
          name: greige_AM?.name || '',
        });
        setProcessingAM({
          newAccountManagerId: processing_AM?.id || null,
          name: processing_AM?.name || '',
        });
        setDenimAM({
          newAccountManagerId: denim_AM?.id || null,
          name: denim_AM?.name || '',
        });
        setIst({
          newAccountManagerId: istUser?.id || null,
          name: istUser?.name || '',
        });
      }
    }
  }, [customer]);
  const onChange = (e) => {
    setValue(e.target.value);
  };
  const onCommentChange = (e) => {
    setComment(e.target.value);
  };
  const showModal = () => {
    setIsModalVisible(true);
  };
  const showAmModal = () => {
    setShowAmEditModal(true);
  };
  const handleOk = () => {
    deactivateCustomer({
      customerId: customer.id,
      deactivationComment: value === "other" ? comment : value,
      userId: currentUser.id,
      actionType: customer?.activationStatus === ACTIVATION_STATUS.activated ? "deactivate" : "activate",
    });
    setIsModalVisible(false);
  };
  const handleAmOk = () => {
    if (!amChanges.greige && !amChanges.processing && !amChanges.denim && !amChanges.ist) {
      return;
    }
    // Same selected AM id is sent for greige, processing and denim.
    // IST is intentionally cleared on AM update.
    const amId = greigeAM.newAccountManagerId;
    updateAccountManager({
      newGreigeAmId: amId,
      newProcessingAmId: amId,
      newDenimAmId: amId,
      newIstId: null,
      customerId: customer.id,
      actionType: "editAM",
      userId: currentUser.id,
    });
    setShowAmEditModal(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const handleAmCancel = () => {
    setShowAmEditModal(false);
  };
  const onSelectChange = (type, e, id) => {
    const selectedAM = { newAccountManagerId: +id.key, name: id.value };
  
    if (type === AM_TYPES.GREIGE) {
      setGreigeAM(selectedAM);
      setAmChanges({ ...amChanges, greige: true });
    } else if (type === AM_TYPES.PROCESSING) {
      setProcessingAM(selectedAM);
      setAmChanges({ ...amChanges, processing: true });
    } else if (type === AM_TYPES.DENIM) {
      setDenimAM(selectedAM);
      setAmChanges({ ...amChanges, denim: true });
    } else if (type === AM_TYPES.IST) {
      setIst(selectedAM);
      setAmChanges({ ...amChanges, ist: true });
    }
  };

  // Single dropdown: keep all three AM states in sync for future use,
  // while payload still sends one shared id for all three fields.
  const onAccountManagerSelect = (e, id) => {
    const selectedAM = { newAccountManagerId: +id.key, name: id.value };
    setGreigeAM(selectedAM);
    setProcessingAM(selectedAM);
    setDenimAM(selectedAM);
    setAmChanges({
      ...amChanges,
      greige: true,
      processing: true,
      denim: true,
    });
  };

  function showDeactivationReason(){
    if(customer?.activationStatus === ACTIVATION_STATUS.deactivated){
      return `Deactivated due to: ${customer.deactivationComment}`;
    }
    return '';
  }

  const { Option } = Select;
    return (  
    <div>
      <PageHeader
        className="site-page-header"
        onBack={() => window.history.back()}
        title={customer && customer.name}
        extra={[
          <div className="am-container">
            <div className="am-item">
              <span>Greige AM:&nbsp; </span>
              <span className="am-name">{greige_AM?.name}</span>
            </div>
            <span className="separator">|</span>
            <div className="am-item">
              <span>Processing AM:&nbsp; </span>
              <span className="am-name">{processing_AM?.name}</span>
            </div>
            <div className="am-item">
              <span className="separator">|</span>
              <span>Denim AM:&nbsp;</span>
              <span className="am-name">{denim_AM?.name}</span>
            </div>
            {istUser && (
              <div className="am-item">
                <span className="separator">|</span>
                <span>IST:&nbsp;</span>
                <span className="am-name">{istUser?.name}</span>
              </div>
            )}
          </div>,
          <Button type="link" onClick={showAmModal}>
            Edit AM
          </Button>,
          <Modal
            title={<span className="title-bold">Edit Account Manager</span>}
            visible={showAmEditModal}
            onOk={(e) => handleAmOk(e)}
            onCancel={handleAmCancel}
            width={500}
            centered
            getContainer={() => document.body}
            okText="Submit" 
            cancelText="Close" 
          >
            <span>
              <h3 className="subtitle">Select New Account Manager</h3>
            </span>
            <Select
              placeholder="Select a person"
              optionFilterProp="children"
              onChange={onAccountManagerSelect}
              className="dropdown-select"
              defaultValue={greigeAM?.name}
              filterOption={(input, option) =>
               option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
              }
              showSearch>
              {filteredAMRoles?.map((am) => (
                <Option key={am.id} value={am.name}>
                  {am.name}
                </Option>
              ))}
            </Select>
            {/*
            <span>
              <h3 className="subtitle">Select New Greige Account Manager</h3>
            </span>
            <Select
              placeholder="Select a person"
              optionFilterProp="children"
              onChange={(e, id) => {
               onSelectChange("greige", e, id);
              }}
              className="dropdown-select"
              defaultValue={greigeAM?.name}
              filterOption={(input, option) =>
               option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
              }
              showSearch>
              {filteredAMRoles?.map((am) => (
                <Option key={am.id} value={am.name}>
                  {am.name}
                </Option>
              ))}
            </Select>
            <span >
              <h3 className="subtitle select-gap">Select New Processing Account Manager</h3>            
            </span>
            <Select
              placeholder="Select a person"
              optionFilterProp="children"
              onChange={(e, id) => {
                onSelectChange("processing", e, id);
              }}
              className="dropdown-select"
              defaultValue={processing_AM?.name}
              filterOption={(input, option) =>
              option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
              }
              showSearch>
              {filteredAMRoles?.map((am) => (
                <Option key={am.id} value={am.name}>
                  {am.name}
                </Option>
              ))}
            </Select>
            <h3 className="subtitle select-gap">Select New Denim Account Manager</h3>
            <Select
              placeholder="Select a person"
              optionFilterProp="children"
              onChange={(e, id) => {
                onSelectChange('denim', e, id);
              }}
              className="dropdown-select"
              defaultValue={denim_AM?.name}
              filterOption={(input, option) =>
                option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
              }
              showSearch>
              {filteredAMRoles?.map((am) => (
                <Option key={am.id} value={am.name}>
                  {am.name}
                </Option>
              ))}
            </Select>
            <h3 className="subtitle select-gap">Select New IST</h3>
            <Select
              placeholder="Select a person"
              optionFilterProp="children"
              onChange={(e, id) => {
                onSelectChange('ist', e, id);
              }}
              className="dropdown-select"
              defaultValue={
                istUser?.name
              }
              filterOption={(input, option) =>
                option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
              }
              showSearch>
              {filteredISTRoles?.map((ist) => (
                <Option key={ist.id} value={ist.name}>
                  {ist.name}
                </Option>
              ))}
            </Select>
            */}
          </Modal>,
          <StatusToggler
            label={'Status'}
            condition={customer?.activationStatus === ACTIVATION_STATUS.activated}
            onFalseLabel={'Deactivate'}
            onTrueLabel={'Activate'}
            onChange={() => showModal()}
          />,
          <Modal
            title={`${
              customer?.activationStatus === ACTIVATION_STATUS.activated ? "Deactivate" : "Activate"
            } ${customer?.name}`}
            visible={isModalVisible}
            onOk={(e) => {(customer?.activeOrders === 0 && customer?.isInternational === 0) && handleOk(e)}}
            onCancel={handleCancel}
            okText={`${
              customer?.activationStatus === ACTIVATION_STATUS.activated ? "Deactivate" : "Activate"
            }`}
          >
            {customer?.activationStatus === ACTIVATION_STATUS.deactivated ? (
              <div>
                <h2>{`Please confirm to activate ${customer?.name}`}</h2>
              </div>
            ) : (
              <div>
                {customer?.isInternational === 1 && (
                  <h2>International customer cannot be deactivated</h2>
                )}
                {customer?.activeOrders > 0 &&
                  customer?.isInternational === 0 && (
                    <h2>{`${customer?.name} has active orders. You cannot deactivate ${customer?.name}.`}</h2>
                  )}
                {customer?.openRequests > 0 && customer?.isInternational === 0 && (
                  <h2>
                    {`Customer has ${customer?.openRequests} active queries.`}
                    <br /> Confirm Deactivate ?
                  </h2>
                )}
                {customer?.activeOrders === 0 &&
                  customer?.isInternational === 0 && (
                    <>
                      <p>Deactivating due to </p>
                      <Radio.Group onChange={onChange} value={value}>
                        <Radio value="Incorrect Customer Details">
                          Incorrect Customer Details
                        </Radio>
                        <br />
                        <Radio value="Payment Issues">Payment Issues</Radio>
                        <br />
                        <Radio value="other">
                          Other
                          {value === "other" ? (
                            <Input
                              className="commentBox"
                              placeholder="Enter other reason"
                              value={comment || ""}
                              onChange={onCommentChange}
                            />
                          ) : null}
                        </Radio>
                      </Radio.Group>
                    </>
                  )}
              </div>
            )}
          </Modal>,
        ]}
      >
        {showDeactivationReason()}
      </PageHeader>
    </div>
  );
};

export default CustomerDetailHeader;
